import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommonWebService, HttpResponse, UserHttpService, AddTraining, TrainingDetail, TrainingSearch } from "../public-api";

@Injectable({
  providedIn: 'root'
})
export class TrainingService {

  constructor(private http: HttpClient,
    private userSessionService: UserHttpService,
    private commonService: CommonWebService) { }
  /*-- Training List--*/
  listTrainings(limit?: number, offset?: number, searchParams?: TrainingSearch): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    if (limit !== undefined) {
      formData.append('limit', limit.toString());
    }
    if (offset !== undefined) {
      formData.append('offset', offset.toString());
    }
    if (searchParams && searchParams.keyword_search !== undefined) {
      formData.append("keyword_search", searchParams.keyword_search ? searchParams.keyword_search : "");
    }
    return this.http.post<HttpResponse<any[]>>("training/trainingList", formData);
  }
  /*-- Add New Training--*/
  createNewTraining(body: AddTraining, trainingId?: string): Observable<HttpResponse<TrainingDetail>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("training_topic_name", body.training_topic_name ? body.training_topic_name : "");
    formData.append("department_name", body.department_name ? body.department_name : "");
    formData.append("instructor_name", body.instructor_name ? body.instructor_name : "");
    formData.append("training_startDate", body.training_startDate ? this.commonService.changeDateFormat(body.training_startDate as Date) : "");
    formData.append("training_endDate", body.training_endDate ? this.commonService.changeDateFormat(body.training_endDate as Date) : "");
    formData.append("training_startTime", body.training_startTime ? body.training_startTime : "");

    formData.append("training_endTime", body.training_endTime ? body.training_endTime : "");
    formData.append("training_timeZone", body.training_timeZone ? body.training_timeZone : "");
    formData.append("training_link", body.training_link ? body.training_link : "");

    formData.append("training_description", body.training_description ? body.training_description : "");
    formData.append("venue_name", body.venue_name ? body.venue_name : "");
    formData.append("training_document", body.training_document ? this.commonService.getFormattedImageBase64(body.training_document) : "");
    formData.append("training_documentname", body.training_documentname ? body.training_documentname : "");
    if (body.users_ids && body.users_ids.length > 0) {
      body.users_ids.forEach((X: any, i: any) => {
        formData.append(`users_ids[${i}]`, X.user_id ? X.user_id : "");
      })
    };
    if (trainingId) {
      formData.append("training_id", trainingId ? trainingId : "");
    }
    return this.http.post<HttpResponse<TrainingDetail>>("training/createTraining", formData);

  }
  /*-- Training Detail--*/
  viewTrainingDetail(training_id: any): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("training_id", training_id ? training_id : "");
    return this.http.post<HttpResponse<any[]>>("training/trainingList/trainingDetail", formData);
  }

  /*--Accept/Decline Training--*/
  accepDeclineTraining(training_id: any, status: string): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("training_id", training_id ? training_id : "");
    formData.append("status", status ? status : "");
    return this.http.post<HttpResponse<any[]>>("training/trainingAcceptDecline", formData);
  }

  /*--Delete Training--*/
  deleteTraining(training_id: any): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("training_id", training_id);
    return this.http.post<HttpResponse<any[]>>("training/trainingList/trainingDelete", formData);
  }
}
